<template>
  <div>
    <div>
      <h5 v-html="(active+1) +'.'+ data[active].examcont+'（'+ data[active].scores+'分）'"></h5>
      <!-- 单选 -->
      <van-radio-group v-if="!multiple" v-model="data[active].examansws">
        <van-radio
          v-for="(m,n) in data[active].examop"
          :key="m.optionid"
          :name="m.optionid"
        >
          <span  v-html="capital[n]+'.&nbsp&nbsp'+m.optioncontent" ></span>
        </van-radio>

      </van-radio-group>
      <!-- 多选 -->
      <van-checkbox-group v-if="multiple" v-model="data[active].examansws">
        <van-checkbox
          v-for="(m,n) in data[active].examop"
          :key="m.optionid"
          shape="square"
          :name="m.optionid"
        >
          <span  v-html="capital[n]+'.&nbsp&nbsp'+m.optioncontent" ></span>
        </van-checkbox>
      </van-checkbox-group>
      <div style="height: 100px;width: 100%" ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      radio: '',
      activeIndex: 0,
      capital: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/examonline/components/singleOpt.vue